export abstract class RlControl{
    constructor(){}
}